import React, {useEffect} from 'react';
import {Navigate, Route, Routes} from "react-router-dom";
import UtilisateurPage from "./UtilisateurPage";
import UtilisateurForm from "./UtilisateurForm";
import {useHeader} from "../../../contexts/HeaderContext";

const UtilisateurWrapper = () => {
  const {setTitle} = useHeader();

  useEffect(() => {
    setTitle("Gestion des Utilisateurs");
  }, [setTitle]);

  return (
    <Routes>
      <Route path='' element={<UtilisateurPage/>}/>
      <Route path='/creer' element={<UtilisateurForm/>}/>
      <Route path='/:id/modifier' element={<UtilisateurForm/>}/>

      <Route path='*' element={<Navigate to='/404' replace/>}/>
    </Routes>
  )
}

export {UtilisateurWrapper}